import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
  `,
  label: css`
    display: block;
    width: 100%;
    max-width: 100%;
    color: ${colors.charcoal};
    overflow-wrap: break-word;
    word-wrap: break-word;
  `,
  container: css`
    & > .MuiButtonBase-root {
      justify-content: flex-start;
    }
    &.MuiInput-underline:after {
      border-bottom: 2px solid ${colors.prussian} !important;
    }
  `,
  optionItem: css`
    padding: 6px 16px !important;
    display: grid !important;
    justify-content: flex-start !important;
  `,
};

export default styles;
